import { ENV } from "./environment";

export const RESUME_ANALYZER_PATH = ENV.RESUME_ANALYSER_BASE_PATH;